import { FormContactUs } from '../../components';
import './Contact.css';

export default function Contact() {
  return (
    <section id='section-contact' className='section-contact'>
      <h1 className='section-heading'>CONTACT ME</h1>
      <div className='container-contact'>
        <div className='section-contact-background'></div>
        <div className='container-form'>
          <FormContactUs />
        </div>
      </div>
    </section>
  );
}
